import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserTie, FaUserGraduate } from 'react-icons/fa'; // Import icons
import '../styles/WelcomePage.css';

function WelcomePage() {
  const navigate = useNavigate();

  const handleHRClick = () => {
    navigate('/login');
  };

  const handleApplicantClick = () => {
    navigate('/applicants');
  };

  return (
    <div className="welcome-page">
      {/* Background Animation */}
      <div className="background-overlay"></div>

      <div className="content">
        <h1 className="heading">Welcome to ApplyGabay</h1>
        <p className="subheading">Your all-in-one platform for managing job applications efficiently.</p>

        {/* Button Container */}
        <div className="button-container">
          <button className="btn hr-btn" onClick={handleHRClick}>
            <FaUserTie className="icon" /> HR Portal
          </button>
          <button className="btn applicant-btn" onClick={handleApplicantClick}>
            <FaUserGraduate className="icon" /> Applicant Portal
          </button>
        </div>

        {/* Feature Cards */}
        <div className="features">
          <div className="card">
            <h3>Streamline Hiring</h3>
            <p>Automate candidate tracking and save valuable time.</p>
          </div>
          <div className="card">
            <h3>User-Friendly Interface</h3>
            <p>Easy navigation for both HR teams and applicants.</p>
          </div>
          <div className="card">
            <h3>Real-Time Updates</h3>
            <p>Stay informed with instant notifications.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomePage;
